import { all, call, debounce, put, takeLatest } from "redux-saga/effects";
import CompanyListService from "../../services/companyList.service";
import {
  getCompanyListFailed,
  getCompanyListSuccess,
  updateCompanyPaymentModeFailed,
  updateCompanyPaymentModeSuccess,
  updateCompanyStatusFailed,
  updateCompanyStatusSuccess,
  updateCompanyInfoFailed,
  updateCompanyInfoSuccess,
  updateCompanyBillingFailed,
  updateCompanyBillingSuccess,
  createCompanyAccountSuccess,
  createCompanyAccountFailed,
} from "./companyListSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* companyListWatcher() {
  yield debounce(1000, "companyList/getCompanyList", getCompanyListSaga);
  yield takeLatest("companyList/updateCompanyStatus", updateCompanyStatusSaga);
  yield takeLatest("companyList/updateCompanyPaymentMode", updateCompanyPaymentModeSaga);
  yield takeLatest("companyList/updateCompanyInfo", updateCompanyInfoSaga);
  yield takeLatest("companyList/updateCompanyBilling", updateCompanyBillingSaga);
  yield takeLatest("companyList/createCompanyAccount", createCompanyAccountSaga);
}

function* getCompanyListSaga(action) {
  try {
    const response = yield call(CompanyListService.getCompanyList, action.payload);

    if (response.status) {
      yield put(getCompanyListSuccess(response.data));
    } else {
      yield put(getCompanyListFailed(response.message));
    }
  } catch (err) {
    console.log("Error: ", err);
  }
}

function* updateCompanyStatusSaga(action) {
  try {
    const response = yield call(CompanyListService.updateCompanyStatus, action.payload);

    if (response.status) {
      yield put(updateCompanyStatusSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(updateCompanyStatusFailed(response.message));
      showErrorToaster(response.message);
    }
  } catch (err) {
    console.log("Error: ", err);
  }
}
function* updateCompanyPaymentModeSaga(action) {
  try {
    const response = yield call(CompanyListService.updateCompanyPaymentMode, action.payload);

    if (response.status) {
      yield put(updateCompanyPaymentModeSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(updateCompanyPaymentModeFailed(response.message));
      showErrorToaster(response.message);
    }
  } catch (err) {
    console.log("Error: ", err);
  }
}

function* updateCompanyInfoSaga(action) {
  try {
    const response = yield call(CompanyListService.updateCompanyInfo, action.payload);

    if (response.status) {
      yield put(updateCompanyInfoSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(updateCompanyInfoFailed());
      showErrorToaster(response.message);
    }
  } catch (err) {
    yield put(updateCompanyInfoFailed());
    console.log("Error: ", err);
  }
}

function* updateCompanyBillingSaga(action) {
  try {
    const response = yield call(CompanyListService.updateCompanyBilling, action.payload);

    if (response.status) {
      yield put(updateCompanyBillingSuccess(action.payload));
      showSuccessToaster(response.message);
    } else {
      yield put(updateCompanyBillingFailed());
      showErrorToaster(response.message);
    }
  } catch (err) {
    yield put(updateCompanyBillingFailed());
    console.log("Error: ", err);
  }
}

function* createCompanyAccountSaga(action) {
  try {
    const response = yield call(CompanyListService.createCompanyAccount, action.payload);

    if (response.status) {
      yield put(createCompanyAccountSuccess());
      showSuccessToaster(response.message);
    } else {
      yield put(createCompanyAccountFailed());
      showErrorToaster(response.message);
    }
  } catch (err) {
    yield put(createCompanyAccountFailed());
    console.log("Error: ", err);
  }
}

export default function* companyListSaga() {
  yield all([companyListWatcher()]);
}
